import React from "react"
import { Navigate } from "react-router-dom"
// Profile

//GeneralProfile
import GeneralProfile from "../pages/Authentication/general-profile"

// Authentication related pages
//import Login from "../pages/Authentication/Login"
import Login from "../pages/Authentication 2.0/Login"
import Register from "pages/Authentication 2.0/Register"
//import Register from "../pages/Authentication/Register"

// Dashboard

import Budgeting from "../pages/Budgeting/index"

import BudgetVersion from "../pages/Budgeting/BudgetVersion"
import BudgetVersionFinal from "../pages/Budgeting/BudgetVersionFinal"
// Calendar
import Contacts from "../pages/Contacts/index"
import Document from "pages/Document/index"
import Teams from "pages/Teams"
import SurveyTypeForm from "pages/Surveys/SurveyTypeForm"
import BancoDePreciosReferenciaC from "pages/BancoPrecios/BancoDePreciosReferenciaC"
import TemplatePage from "pages/BancoPrecios/templatePage"
import SelectReferencia from "pages/BancoPrecios/selectReferencia"

import ModalPartidas from "pages/ModalPartidas/index"

import BancoPreciosIndex from "pages/BancoPrecios/BancoPreciosIndex"
import Template from "pages/BancoPrecios/Template"
import SubscriptionPage from "pages/GestionEmpresa/subscriptionPage"
import SubscriptionPageAnual from "pages/GestionEmpresa/subscriptionPageAnual"
import SubscriptionPayment from "components/GestionEmpresa/subscriptionPayment"
import FavoritesPage from "pages/BancoPrecios/favoritesPage"
import Profile from "pages/ProfileRefinament/Profile"
import PasswordRecoveryFlow from "pages/Authentication 2.0/PasswordFlow"
import newCreateAct from "pages/NewActs/indexCreateAct"
import NewEditAct from "pages/NewActs/indexEditAct"
import PartBrowserPage from "pages/PartBrowser/index"
import Invoices from "pages/Invoices/Invoices"
import Invoice from "pages/Invoices/Invoice"
import PurchaseOrder from "pages/PurchaseOrders/purchaseOrder"
import PurchaseOrders from "pages/PurchaseOrders/purchaseOrders"

import IndexActas from "pages/Actas/indexActas"
import TemplateManagement from "pages/TemplatesManagement"
import BudgetingIndex from "pages/BudgetingPage2023/BudgetingIndex"
import IndexProjectPage from "pages/Document/insideProjectPage"
import NewDashboard from "pages/Dashboard/newDashboard"
import NewPlantillaPdf from "pages/NewPlantillaPdf/newPlantillaPdf"
import TemplatePageV2 from "pages/BancoPrecios/templatePageV2"
import CertificacionesIndex from "pages/Certificaciones/CertificacionesIndex"
import CertificationsHistoryIndex from "pages/CertificationsHistory/CertificationsHistoryIndex"
import ExtrasAndContradictionsIndex from "pages/ExtrasAndContradictions/ExtrasAndContradictionsIndex"
import DynamicElementsIndex from "pages/DynamicElements/DynamicElementsIndex"
import GestionCostesIndex from "pages/GestionCostes/GestionCostesIndex"
import DynamicElementsProject from "pages/DynamicElements/DynamicElementsProject"
import Overview from "pages/Overview"

const authProtectedRoutes = [
  //demo

  { path: "/dashboard", component: NewDashboard },
  { path: "/contacts", component: Contacts },

  // //profile
  { path: "/profile", component: Profile },
  {
    path: "/subscription",
    component: SubscriptionPage,
  },
  {
    path: "/subscriptionAnual",
    component: SubscriptionPageAnual,
  },
  {
    path: "/subscription/:planName",
    component: SubscriptionPayment,
  },
  {
    path: "/gestionEquipo",
    component: Teams,
  },
  { path: "/budgetingCalc/:projectId", component: Budgeting },
  { path: "/invoices/", component: Invoices },
  {
    path: "/invoices/:projectId",
    component: Invoices,
  },
  {
    path: "/invoice/:invoiceId/:projectId",
    component: Invoice,
  },
  {
    path: "/invoice/:invoiceId",
    component: Invoice,
  },
  {
    path: "/purchase-orders",
    component: PurchaseOrders,
  },
  {
    path: "/purchase-orders/:projectId",
    component: PurchaseOrders,
  },
  {
    path: "/purchase-order/:purchaseOrderId/:projectId",
    component: PurchaseOrder,
  },
  {
    path: "/purchase-order/:purchaseOrderId",
    component: PurchaseOrder,
  },
  {
    path: "/templateManagement",
    component: TemplateManagement,
  },
  {
    path: "/budgeting/:projectId",
    component: BudgetingIndex,
  },
  {
    path: "/overview/:projectId",
    component: Overview,
  },
  {
    path: "/certificaciones/:projectId",
    component: CertificacionesIndex,
  },
  {
    path: "/certhistory/:projectId",
    component: CertificationsHistoryIndex,
  },
  // { path: "/extras/:projectId", component: BudgetingIndex },
  // utilizo el BudgetingIndex pero el problema es que luego al moverse de una tab al otra no se actualiza el arbol y queda con los caps de extras y contradict (posiblemente habria que hacer algo parecido como lo hace en certificaciones, revisar el CertificacionesIndex)
  {
    path: "/extras/:projectId",
    component: ExtrasAndContradictionsIndex,
  },
  {
    path: "/dynamicElements/:projectId",
    exact: true,
    component: DynamicElementsProject,
  },
  {
    path: "/actas/:projectId",
    component: IndexActas,
  },

  { path: "/equipos/:projectId", component: Teams },

  {
    path: "/versions/:projectId/:index",
    component: BudgetVersion,
  },
  {
    path: "/versions/final/:projectId/:index",
    component: BudgetVersionFinal,
  },
  {
    path: "/generalProfile",
    component: GeneralProfile,
  },
  {
    path: "/expenses",
    component: GestionCostesIndex,
  },
  {
    path: "/expenses/:projectId",
    component: GestionCostesIndex,
  },
  {
    path: "/bancodeprecios",
    component: BancoPreciosIndex,
  },
  {
    path: "/bancodeprecios/referencia/:referencia",
    component: BancoDePreciosReferenciaC,
  },
  {
    path: "/bancodeprecios/referencia/:referencia/:tipo",
    component: BancoDePreciosReferenciaC,
  },
  {
    path: "/bancodeprecios/templates",
    component: Template,
  },
  {
    path: "/bancodeprecios/favorites/myBP",
    component: FavoritesPage,
  },
  {
    path: "/bancodeprecios/favorites/referenciaC",
    component: FavoritesPage,
  },
  {
    path: "/bancodeprecios/favorites/referenciaB",
    component: FavoritesPage,
  },
  {
    path: "/bancodeprecios/favorites/referenciaC",
    component: FavoritesPage,
  },
  {
    path: "/bancodeprecios/favorites/templates",
    component: FavoritesPage,
  },
  {
    path: "/bancodeprecios/template/:templateId",
    component: TemplatePage,
  },
  {
    path: "/bancodeprecios/templateV2/:projectId",
    component: TemplatePageV2,
  },
  {
    path: "/createAct/:projectId/",
    component: newCreateAct,
  },
  {
    path: "/editAct/:projectId/:actId",
    component: NewEditAct,
  },
  {
    path: "/bancodeprecios/select",
    exact: true,
    component: SelectReferencia,
  },
  {
    path: "/bancodeprecios/dynamic-element",
    exact: true,
    component: DynamicElementsIndex,
  },

  { path: "/documents", component: Document },
  {
    path: "/documents/:projectId",
    component: IndexProjectPage,
  },
  { path: "/onboarding", component: SurveyTypeForm },

  //ruta especifica para mostrar modal de partidas
  { path: "/modalpartidas", component: ModalPartidas },
  { path: "/general-pdf", component: NewPlantillaPdf },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Navigate to="/dashboard" /> },
]

const publicRoutes = [
  { path: "/login", component: Login },
  { path: "/register", component: Register },
  { path: "/forgot-password", component: PasswordRecoveryFlow },
  { path: "/part-browser", component: PartBrowserPage },
]

export { publicRoutes, authProtectedRoutes }
